import { isDynamicValue } from './dynamicBindings';
import { getBulkComputedData } from './getBulkComputedData';
import { getComputedData, type ShouldPreserveExpression } from './getComputedData';

export const getNoCodeComputedData = <T>(
  data: Record<string, unknown> | string | unknown[],
  context: Record<string, unknown>,
  shouldEvaluateResult?: (result: string) => boolean,
  shouldPreserveExpression?: ShouldPreserveExpression,
  onError?: (e: unknown) => void,
) => {
  return getComputedData<T>(
    data,
    context,
    shouldEvaluateResult ?? isDynamicValue,
    shouldPreserveExpression,
    onError,
  );
};

export const getNoCodeBulkComputedData = <T extends Record<string, string>>(
  data: T,
  context: Record<string, unknown>,
  shouldEvaluateResult?: (result: string) => boolean,
) => {
  return getBulkComputedData<T>(data, context, shouldEvaluateResult ?? isDynamicValue);
};
